import React from "react";
import { Controller } from "react-hook-form";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { canadaGibsonFont } from "../Config";

export default function RHFRadio({
    name,
    label,
    control,
    options = [],
    defaultValue = "",
    row = false,
    disabled = false,
    ...muiProps
}) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={(field) => (
                <FormControl
                    component="fieldset"
                    disabled={disabled}
                    sx={{
                        "& .MuiFormControlLabel-label": {
                            textDecoration: "none",
                            fontWeight: "lighter",
                            ...canadaGibsonFont,
                        },
                    }}
                >
                    {label && (
                        <FormLabel
                            component="legend"
                            sx={{
                                fontWeight: "lighter",
                                ...canadaGibsonFont,
                            }}
                        >
                            {label}
                        </FormLabel>
                    )}
                    <RadioGroup {...field} row={row} {...muiProps}>
                        {options.map((opt) => (
                            <FormControlLabel
                                key={opt.value}
                                value={opt.value}
                                control={<Radio disabled={disabled} />}
                                label={opt.label}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            )}
        />
    );
}
